export default {"src":"/_next/static/image/public/images/flags/flag_994.fe8ce2ef306a80f4933ae8a73a915934.svg","height":16,"width":25};